import { TextFormatBold16 } from 'ui/icons/aurora/16px/TextFormatBold16';
import { useFormattingContext } from '../contexts/formatting';
import { useTranslation } from '../../../../../hooks/useTranslation';
import { BaseToolbarButton } from './BaseToolbarButton';

export const ToggleBoldButton = () => {
  const { t } = useTranslation();
  const { isBoldEnabled, toggleBold } = useFormattingContext();
  return (
    <BaseToolbarButton
      isSelected={isBoldEnabled}
      onClick={toggleBold}
      tooltip={t('contentPicker.textEditor.bold')}
      data-test="bold-button"
    >
      <TextFormatBold16 isColorInherited />
    </BaseToolbarButton>
  );
};
